import Component from "../../../../js/assets/component.js"

class ButonTourLP extends Component {
  constructor(el, blockIndex){
    super(el)
  }

  activate(){
    this.$el.removeClass("-inActive")
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
    this.$el.addClass("-inActive")
  }

  mounted() {

  }
}

export default ButonTourLP
